import { Component, OnInit } from '@angular/core';
import { ConnectRestService } from '../services/connect-rest.service';
import { Router, ActivatedRoute } from '@angular/router'


@Component({
  selector: 'app-identify-exist',
  templateUrl: './identify-exist.component.html',
  styleUrls: ['./identify-exist.component.scss']
})
export class IdentifyExistComponent implements OnInit {

  IsLink : boolean= false
  DisplayNextButton: boolean = true
  ErrorDescription: any
  ErrorDescription1: any
  ErrorDescription2: any
  constructor(    
    private connect: ConnectRestService,
    private router: Router,
    private activeRoute :ActivatedRoute
  ) {     
            this.ErrorDescription = this.activeRoute.snapshot.paramMap.get("ErrorDescription")
            this.ErrorDescription1 = this.activeRoute.snapshot.paramMap.get("ErrorDescription1")
            this.ErrorDescription2 = this.activeRoute.snapshot.paramMap.get("ErrorDescription2")
            this.IsLink = this.activeRoute.snapshot.paramMap.get("ErrorCode")=="EC003"?true:false
            this.DisplayNextButton = this.activeRoute.snapshot.paramMap.get("ErrorCode")!="EC010"?true:false
  }

  ngOnInit() {
  }

  async onSubmit(){
    var RequestData = JSON.parse(sessionStorage.RequestData)
    RequestData.IsNewCase = true
    var ServiceHeader = JSON.parse(sessionStorage.ServiceHeader)
    ServiceHeader.CaseID = null
    sessionStorage.ServiceHeader = JSON.stringify(ServiceHeader)
    var responseData = await this.connect.connectRest(RequestData,"S0010",'')
    if(responseData.Status == "Success"){
      sessionStorage.removeItem('RequestData')
      sessionStorage.removeItem('ErrorDescription')
      sessionStorage.removeItem('ErrorDescription1')
      sessionStorage.removeItem('ErrorDescription2')
      sessionStorage.removeItem('ErrorCode')
      this.router.navigate(['/director-details'])
    }
  }

  async onResend(){
    var responseData = await this.connect.connectRest({},"R0310",'')
    if(responseData.Status == "Success"){  
      this.IsLink = false
      this.DisplayNextButton = false
      this.ErrorDescription = "The email with retrievable URL has been sent to the applicant's email address."
      this.ErrorDescription1 = "If you do not receive the email, it could be due to the contact details provided were incorrect."
      this.ErrorDescription2 = "Please click Next to create a new application."
    }
  }
}
